import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';
import './Waitlist.css';

const Waitlist = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      setStatus('Please enter a valid email');
      return;
    }

    setIsSubmitting(true);
    try {
      await addDoc(collection(db, 'waitlist'), {
        email,
        timestamp: new Date(),
      });
      setStatus('Thanks for joining our waitlist!');
      setEmail('');
    } catch (error) {
      console.error('Error adding to waitlist:', error);
      setStatus('Something went wrong. Please try again.');
    }
    setIsSubmitting(false);
  };

  return (
    <div className="waitlist-container">
      <h2>Join the Waitlist</h2>
      <p>Be the first to know when we launch!</p>
      
      <form onSubmit={handleSubmit} className="waitlist-form">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          className="waitlist-input"
          required
        />
        <button 
          type="submit" 
          className="waitlist-button"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Joining...' : 'Join Waitlist'}
        </button>
      </form>
      
      {status && (
        <p className={`status-message ${status.includes('Thanks') ? 'success' : 'error'}`}>
          {status}
        </p>
      )}
    </div>
  );
};

export default Waitlist; 